export const longDescriptionColor = 'text-black/80';

export const jabraTheme = {
  light: {
    backgroundColor: 'bg-blue-50',
    primaryTextColor: 'text-blue-900',
    secondaryTextColor: 'text-blue-700',
  },
  default: {
    backgroundColor: 'bg-white',
    primaryTextColor: 'text-green-900',
    secondaryTextColor: 'text-green-400',
  },
};

export const tspTheme = {
  backgroundColor: 'bg-[var(--tsp-surface)]',
  primaryTextColor: 'text-[var(--tsp-text-primary)]',
  secondaryTextColor: 'text-[var(--tsp-text-secondary)]',
};
